module.exports = __webpack_public_path__ + "c0e05d98e3ee3bcd69d22a97873028b5.svg";